import { PrimaryGeneratedColumn, Entity, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Index } from 'typeorm';
import { DbNamesEnum } from '../migration/db-connection/db-names.enum';

@Entity('m_line')
export class LineEntity {
    @PrimaryGeneratedColumn('increment',{
        name:'id'
    })
    id: string;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'line_id'
    })
    lineId: string;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'line_number'
    })
    lineNumber: string;

    @Column('varchar', {
        nullable: true,
        length: 50,
        name: 'line_desc'
    })
    lineDesc: string;

    @Column('varchar', {
        nullable: false,
        length: 30,
        name: 'db_host'
    })
    dbHost: string;

    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'db_name'
    })
    dbName: DbNamesEnum;

    @Column('varchar', {
        nullable: false,
        length: 30,
        name: 'db_username'
    })
    dbUsername: string;

    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'db_password'
    })
    dbPassword: string;

    @Column('int',{
        nullable:false,
        name:'db_port'
    })
    port: number;

    @Column('varchar',{
        nullable:false,
        length: 10,
        name:'unit_id'
    })
    unitId: string;

    @Column('boolean',{
        nullable:false,
        default: true,
        name:'is_active'
    })
    isActive:boolean;

    @CreateDateColumn({name: 'created_at'})
    createdAt: Date;

    @UpdateDateColumn({name: 'updated_at'})
    updatedAt: Date;
}